module.exports = __webpack_public_path__ + "static/img/ent-detail-72.bf82a20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-72.jpg
// module id = XM/a
// module chunks = 52